const providerPrice = (price, percent) => {
    return price - ( percent / 100 * price );
};

export {
    providerPrice
};
